var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-button',{attrs:{"variant":_vm.variant,"title":_vm.withText?'delete':'',"icon":_vm.withIcon?'trash-alt':'',"size":_vm.size,"is-disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }